<template>
  <!-- 로그인 카드의 머리 — POS2 Lite `OwnerUi.OwnerHead` 와 같은 모양: 작은 머리말(선택) · 제목 · 한 줄(선택). 말은 부른 화면이 번역해 준다 -->
  <div class="owner-head">
    <p v-if="kick" class="owner-kick">{{ kick }}</p>
    <p class="owner-title">{{ title }}</p>
    <p v-if="sub" class="owner-sub"><sentence-lines :text="sub"></sentence-lines></p>
  </div>
</template>

<script>
import SentenceLines from '@/components/common/SentenceLines.vue'

/** 로그인 화면(사장님·아이디 탭)·매장 고르기·비밀번호 찾기가 같이 쓰는 머리 */
export default {
  name: 'OwnerHead',
  components: { SentenceLines },
  props: {
    kick: { type: String, default: '' },
    title: { type: String, required: true },
    sub: { type: String, default: '' },
  },
}
</script>

<style scoped>
.owner-head {
  text-align: left;
  margin-bottom: 20px;
  word-break: keep-all;
  text-wrap: pretty;
}
.owner-kick {
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-primary);
}
.owner-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  color: var(--color-text-primary);
  text-wrap: balance;
}
.owner-sub {
  margin: 6px 0 0;
  font-size: 14px;
  line-height: 20px;
  color: var(--color-text-secondary);
}
</style>
